var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"checkbox","id":"menu-btn","name":""}}),_c('SideBar'),_c('Main'),_c('TopNav'),_c('Panel1'),_c('Panel2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }